/* Progressive enhancement: all collection links scroll natively without JavaScript. */
(function () {
  'use strict';
  const categoryWindow = (items, step, stride) => items.map((_, i) => items[(step * stride + i) % items.length]);
  if (typeof module !== 'undefined' && module.exports) module.exports = { categoryWindow };
  if (typeof document === 'undefined') return;
  function init(root = document) {
    root.querySelectorAll('[data-home-section]').forEach(home => {
      if (home.dataset.homeReady) return;
      home.dataset.homeReady = 'true';
      const rows = [...home.querySelectorAll('[data-category-row]')];
      const originals = rows.map(row => [...row.children]);
      const next = home.querySelector('[data-category-next]');
      const status = home.querySelector('[data-category-status]');
      const preference = matchMedia('(prefers-reduced-motion: reduce)');
      let step = 0;
      let animations = [];
      const ghosts = new Set();
      const stop = () => {
        animations.forEach(animation => animation.cancel());
        animations = [];
        ghosts.forEach(ghost => ghost.remove());
        ghosts.clear();
      };
      const advance = () => {
        stop();
        step = (step + 1) % 20;
        rows.forEach((row, i) => {
          const stride = i === 0 ? 2 : 1;
          const ghost = row.cloneNode(true);
          ghost.removeAttribute('data-category-row');
          ghost.classList.add('category-motion-ghost');
          ghost.inert = true;
          ghost.setAttribute('aria-hidden', 'true');
          const distance = (row.children[0].getBoundingClientRect().width + parseFloat(getComputedStyle(row).columnGap)) * stride;
          categoryWindow(originals[i], step, stride).forEach(card => row.append(card));
          row.scrollLeft = 0;
          if (preference.matches || !row.animate || document.visibilityState === 'hidden') return;
          row.parentElement.append(ghost);
          ghosts.add(ghost);
          const options = { duration: 320, easing: 'cubic-bezier(.22,.61,.36,1)' };
          const outgoing = ghost.animate([{ transform: 'translateX(0)' }, { transform: `translateX(${-distance}px)` }], options);
          const incoming = row.animate([{ transform: `translateX(${distance}px)` }, { transform: 'translateX(0)' }], options);
          animations.push(outgoing, incoming);
          Promise.allSettled([outgoing.finished, incoming.finished]).then(() => { ghost.remove(); ghosts.delete(ghost); });
        });
        if (status) status.textContent = rows.map(row => [...row.children].slice(0, 3).map(card => card.textContent.trim()).join(', ')).join('; ');
      };
      if (next && rows.length === 2) { next.hidden = false; next.addEventListener('click', advance); }
      // A preference change settles the current semantic state immediately.
      preference.addEventListener('change', stop);
      rows.forEach(row => row.addEventListener('pointerdown', stop, { passive: true }));
      const header = document.getElementById('shopify-section-header');
      const measure = () => {
        const height = header?.getBoundingClientRect().height || 0;
        if (height) home.style.setProperty('--home-header-height', `${height}px`);
        stop();
      };
      measure();
      const observer = typeof ResizeObserver === 'function' ? new ResizeObserver(measure) : null;
      if (header) observer?.observe(header);
      window.addEventListener('resize', measure, { passive: true });
      home._homeCleanup = () => { stop(); observer?.disconnect(); preference.removeEventListener('change', stop); window.removeEventListener('resize', measure); next?.removeEventListener('click', advance); delete home.dataset.homeReady; };
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('[data-home-section]').forEach(home => home._homeCleanup?.()));
})();
